/// <reference types="./renewAdvisoryLock.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
export async function renewAdvisoryLock(databaseAdapter, context, name, handle) {
    const { logger, session } = context;
    if (session.type === 'readonly') {
        return notOk.BadRequest('Readonly session used to renew advisory lock');
    }
    const result = await databaseAdapter.advisoryLockRenew(context, name, handle);
    if (result.isError())
        return result;
    const { acquiredAt, renewedAt } = result.value;
    logger.info(`Renewed advisory lock: ${name}`);
    return ok({ name, handle, acquiredAt, renewedAt });
}
//# sourceMappingURL=renewAdvisoryLock.js.map